<template>
	<div>
		<div class="list-btn">
			<!-- <Button type="primary" @click="ret">返回</Button> -->
		</div>
		<div>
			 <Tag color="blue">金额：{{totalMoney}}元</Tag>
			 <Tag color="blue">订单数：{{totalOrderNumber}}</Tag>
			 <Tag color="blue">销售量：{{totalCommNumber}}</Tag>
			  <DatePicker type="date"  placeholder="请选择日期" style="width: 200px"  v-model="shijian1" @on-change="onchange"> </DatePicker>
			  
			  <Button type="info" @click="daochu">导出</Button>
		</div>
		<div style="display: flex;width: 90%;justify-content: center;">{{shijian}}  销售曲线图</div>
		<Row>
			<Card shadow>
				<example v-if="hackResetZXT" style="height: 310px;" :series='zxt.series' :xAxisData="zxt.xAxisData" :name="zxt.name" :end="zxt.end" />
			
			</Card>
		</Row>
		<Table border ref="selection" :columns="columns12" :data="data6" @on-selection-change="selection" :loading="loading">
		
			<template slot-scope="{ row, index }" slot="action">
				<Button type="primary" size="small" style="margin-right: 5px" @click="xiangqing(row)">详情</Button>
			</template>
		</Table>
	</div>
</template>

<script>
	import InforCard from '../../../comm/info-card/infor-card.vue'
	import CountTo from '../../../comm/count-to/count-to.vue'
	import {
		ChartPie,
		ChartBar
	} from '../../../comm/charts'
	import Example from './example.vue'
	import http from '../../../../http/http.js'
	let _this = this
	export default {
		name: 'home',
		components: {
			InforCard,
			CountTo,
			ChartPie,
			ChartBar,
			Example
		},
		created() {
			_this = this
			console.log(_this.$route.query.year)
			if(_this.$route.query.year!=undefined){
				this.query.year=_this.$route.query.year
				this.query.month=_this.$route.query.month
				this.query.day=_this.$route.query.day
				this.shijian=this.query.year+"年-"+this.query.month+"月"+this.query.day+"日"
				this.shijian1=this.query.year+"年-"+this.query.month+"月"+this.query.day+"日"
			}else{
				var date = new Date();
				let year=parseInt(date.getFullYear()); //获取完整的年份(4位)
				let month=parseInt(date.getMonth())+1; //获取当前月份(0-11,0代表1月)
				let day=parseInt(date.getDate()); //获取当前日(1-31)
				this.shijian=year+"年-"+month+"月-"+day+"日"
				this.shijian1=year+"年-"+month+"月-"+day+"日"
				
				this.query.year=year
				this.query.month=month
				this.query.day=day
			}
			
			_this.queryDay()
		},
		data() {
			return {
				loading:false,
				shijian:'',
				totalMoney:0,
				totalOrderNumber:0,
				totalCommNumber:0,
				hackResetZXT: false,
				zxt: {
					series: [{
						name: '销售额(元)',
						type: 'line',
						stack: '总量',
						// areaStyle: {
						// 	normal: {
						// 		color: '#2176FA'
						// 	}
						// },
						data: []
					}],
					end: 100, //显示的数据百分比
					name: '今日销售情况',
					xAxisData: [
					]
				},
				query:{
					year: 2020,
					month: 9,
					day:8
				},
				columns12: [
					{
							title: 'id',
							key: 'id'
					},
					{
							title: '订单标识',
							key: 'orderCode'
					},
					{
						title: '支付方式',
						key: 'payType'
					},
					{
						title: '设备编号',
						key: 'macLeaveFactoryId'
					},
					{
						title: '总金额',
						key: 'money'
					},
					{
						title: '商品数量',
						key: 'number',
					},
					{
						title: '指令是否下发',
						key: 'isShipment',
						render: (h, params) => {
							if(params.row.isShipment){
								return h("div",{
									style: {
									             color: '#19be6b'
									          }
								},"指令已下发")
							}else{
								return h("div",{
									style: {
									             color: '#ed4014'
									          }
								},"指令未下发")
							}
							
						}
					},
					{
						title: '出货结果',
						key: 'result',
						render: (h, params) => {
							if(params.row.result=='正常'){
								return h("div",{
									style: {
									             color: '#19be6b'
									          }
								},"正常")
							}else if(params.row.result=='暂无'){
								return h("div",{
									style: {
									             color: '#ff9900'
									          }
								},"暂无")
							}else{
								return h("div",{
									style: {
									             color: '#ed4014'
									          }
								},"异常")
							}
							
							
						}
					},
					
					{
						title: '是否退款',
						key: 'refund',
						render: (h, params) => {
							return h("div",params.row.refundMoney)
						}
					},
					{
						title: '时间',
						key: 'createdTime'
					},
					{
						title: '操作',
						slot: 'action',
						width: 120,
						align: 'center'
					}
				],
				data6: [
				],
				
			}
		},

		methods: {
			daochu(){
				let _this=this
				_this.$refs.selection.exportCsv({
					
				});
				 
			},
			ret() { //返回上一页
				this.$router.go(-1)
			},
			xiangqing(item){
				this.$router.push({
					name: 'alliance/finance/list1',
					query: {
						orderId: item.id,
					}
				})
			},
			onchange(a,b){
					this.shijian=a
					
					this.query.year=a.split('-')[0]
					this.query.month=a.split('-')[1]
					this.query.day=a.split('-')[2]
					this.queryDay()
				
			},
			queryDay() {
				_this.loading=true
				http.http({
					//这里是你自己的请求方式、url和data参数
					method: 'post',
					url: http.url + '/fin/report/comm/alliance/allianceDayFin',
					data: _this.query,
					_this: _this,
					success: function(data) {
						_this.loading=false
						_this.totalMoney=data.totalMoney
						_this.totalOrderNumber=data.totalOrderNumber
						_this.totalCommNumber=data.totalCommNumber
						let list=data.list
						_this.data6 =list
						console.log(list)
						_this.zxt.xAxisData=[]
						_this.zxt.series[0].data=[]
						for (var i = 0; i < list.length; i++) {
							let item=list[i]
							_this.zxt.xAxisData.push(item.createdTime.substring(11,19))
							_this.zxt.series[0].data.push(item.money)
						}
						
						if(list.length>0){
							let a=50/list.length
							if(a<1){
								_this.zxt.end=list.length*a
							}
						}
						_this.hackResetZXT = false
						_this.$nextTick(() => {
							_this.hackResetZXT = true
						})
					}
					//假设后台需要的是表单数据这里你就可以更改
				})
			}
		},
		//修改首页的meta值，false时再次进入页面会重新请求数据。
		beforeRouteLeave(to, from, next) {
			if(to.name=='alliance/baobiao/list/month'){
				
				from.meta.keepAlive = false;
				this.$destroy(); //销毁B的实例
				next();//当我们前进的不是C时我们让B页面刷新
			}else{
				to.meta.keepAlive=true;
				//from.meta.keepAlive=true;//当我们进入到C时开启B的缓存
				
				next()
			}
		}, 
	}
</script>

<style lang="less">
	.count-style {
		font-size: 50px;
	}
</style>



// WEBPACK FOOTER //
// src/components/alliance/finance/baobiao/day.vue